// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1dwSL","upload":"Small_upload__ywGAl","imageWrap":"Small_imageWrap__3cMYv","removeBtn":"Small_removeBtn__2QCSE"};